export default __webpack_public_path__ + "static/media/ibrahem.71677415.jpg";